import { observer } from 'mobx-react-lite';

import { Box, BoxProps, Grid, styled } from '@mui/material';
import GridContainer from '../components/container/GridContainer';
import CardContainer from '../components/cards/CardContainer';
import useMedia from '../hooks/useMedia';
import OilPricesTable from '../components/tables/OilPricesTable';

const Container = styled(Box)<BoxProps>(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const OilPricesPage = observer((): JSX.Element => {
  // welcomeApi
  const isMobile = useMedia('md');

  const title = 'Ölpreise';

  return (
    <GridContainer>
      <Grid container>
        <Grid item xs={12} marginTop={2}>
          <Container>
            <CardContainer
              title={title}
              customStyle={{
                sx: {
                  margin: isMobile ? 0 : 5,
                },
              }}
              iconOn
              iconName={title}
            >
              <OilPricesTable />
            </CardContainer>
          </Container>
        </Grid>
      </Grid>
    </GridContainer>
  );
});

export default OilPricesPage;
